import { UniverseType } from 'src_common/common/universe';
import { ConfigTypes } from 'src/AppState/ConfigState/types';

type FeaturesDevType = Partial<ConfigTypes>;

export const featuresDev: Record<UniverseType, FeaturesDevType> = {
    akbets: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: 'GTM-K2B3ZDW',
        workbookView: {},
        usePaymentFormForUniverse: {
            type: 'multi-deposit', //  paysafe - energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
        },
        hasNewMenu: true,
        deceased: true,
    },
    bresbet: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: 'GTM-TKB2WP4',
        workbookView: {},
        usePaymentFormForUniverse: {
            type: 'multi-deposit', //  paysafe - energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
        },
    },
    betstgeorge: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gamstopNew: true,
        gtm: 'GTM-TKB2WP4',
        workbookView: {},
    },
    energy: {
        gamprotect: {
            enabled: true,
            brand: 'nrg.bet',
        },
        gtm: 'GTM-5VGX49HT',
        workbookView: {},
        usePaymentFormForUniverse: {
            type: 'paysafe', // energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
            openBanking: null,
        },

        promotionHistoryEnabled: true,
    },
    mcbookie: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: 'GTM-K38BPKH',
        workbookView: {},
        hasNewMenu: true,
        deceased: true,
    },
    planetsportbet: {
        gamstopNew: true,
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: 'GTM-T436JZ9',
        workbookView: {},
    },
    star: {
        gtm: 'GTM-PB3DSS3',
        reportsV2: true,
        hasNewMenu: true,
        deceased: true,
    },
    dragonbet: {
        gamprotect: {
            enabled: true,
            brand: 'dragonbet.co.uk',
        },
        gtm: 'GTM-5XLK49J7',
        configurationManagerUI: true,
        workbookView: {},
        idMission: true,
        casinoStoreEnabled: false,
        usePaymentFormForUniverse: {
            type: 'paysafe', // energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
            openBanking: null,
        },
    },
    gentlemanjim: {
        gamprotect: {
            enabled: true,
            brand: 'gentlemanjim.bet',
        },
        gtm: 'GTM-N4WNV83H',
        workbookView: {},
        idMission: true,
        usePaymentFormForUniverse: {
            type: 'multi-deposit', //  paysafe - energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
        },
    },
    pricedup: {
        idMission: true,
        gamprotect: {
            enabled: true,
            brand: 'PricedUp',
        },
        gamstopNew: true,
        gtm: 'GTM-5ZW23KDB',
        promotionHistoryEnabled: true,
        usePaymentFormForUniverse: {
            type: 'paysafe', // energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '',
            },
            openBanking: null,
        },
        hasXtremepush: true,
    },
    betwright: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        usePaymentFormForUniverse: {
            type: 'paysafe',
            apiKey: 'T1QtMTEwODUwMDpCLXFhMi0wLTY3NjQ0YTIyLTAtMzAyYzAyMTQ2YzZiNmU0M2JmNDA2M2M5NWVkZWZiMTMxNTBlZTRkYjgzMmVhNDVmMDIxNDc4OTVjZDY0OTk5OWY4Y2E3OTAxMDU5Y2NmZjBhYzE0NmEyYWEzZmI=',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002809990',
                EUR: '',
            },
            openBanking: null,
        },
    },
    bestodds: {
        gamstopPpBlockedSuspendedActions: true,
        gamprotect: {
            enabled: true,
            brand: '',
        },
        usePaymentFormForUniverse: {
            type: 'paysafe', // energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
            openBanking: null,
        },
    },
    londonbet: {
        casinoProviders: {
            casino: ['leap', 'pragmatic', 'blueprint', 'relax', 'sg-digital'],
            'live-casino': ['pragmatic'],
            virtuals: ['pragmatic', 'leap'],
        },
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: 'GTM-TFWLFXXS',
        usePaymentFormForUniverse: {
            type: 'paysafe', // energy stg
            apiKey: 'T1QtMTA5MDQ4MDpCLXFhMi0wLTY2MDE4ZDAxLTAtMzAyZDAyMTUwMDhhMWJlYWI2N2MyMzUwNWI5ZWFkNjcyNDYzODhlNjcwOGU0YjEzMzIwMjE0Nzg3MWFiMjk4MGU2MWNmNzhiYTE5MmVmMWQ0MDkzMGRjYTIwNGE0ZQ==',
            environment: 'TEST',
            cardAccounts: {
                GBP: '1002730340',
                EUR: '1002730150',
            },
            openBanking: null,
        },
    },
    properbet: {
        gamprotect: {
            enabled: true,
            brand: '',
        },
        gtm: '',
        workbookView: {},
    },
};
